export const APPROVALS_ENDPOINTS = {
  roles: 'enrollment-approval/listapprovalrole',
  listUsers: 'enrollment-approval/listapprovalusers',
  singleUserDetails: 'enrollment-approval/getuserdetails',
  approve_reject: 'enrollment-approval/action',
} as const;
